import type {
  DehydratedState,
  VueQueryPluginOptions,
} from '@tanstack/vue-query';
import {
  QueryClient,
  VueQueryPlugin,
  dehydrate,
  hydrate,
} from '@tanstack/vue-query';

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>('vue-query');

  // Modify your Vue Query global settings here
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        retry: false,
      }, // 5 minutes
    },
  });
  const options: VueQueryPluginOptions = { queryClient };

  nuxt.vueApp.use(VueQueryPlugin, options);

  if (import.meta.server) {
    nuxt.hooks.hook('app:rendered', () => {
      vueQueryState.value = dehydrate(queryClient);
    });
  }

  // vue-query 5.102+ no longer no-ops on null/undefined dehydrated state.
  // Skip when SSR never wrote payload (common when no queries ran on the server).
  if (import.meta.client) {
    nuxt.hooks.hook('app:created', () => {
      if (vueQueryState.value == null) {
        return;
      }

      hydrate(queryClient, vueQueryState.value);
    });
  }
});
